import {
  LOGIN_USER, LOGOUT_USER, SET_LOGIN_DATA, LOGIN_SERVER_ERROR, ERROR, SET_LOGIN_ERRORS, START_LOADING, FORGOT_PASSWORD
} from '../actions/types';
import LoginForm from '../models/loginForm';
import LoginErrors from '../models/loginErrors';
import HttpError from '../models/httpError';

const INITIAL_STATE = {
  user: localStorage.getItem("user") || null,
  loading: false,
  is_logged_in: localStorage.getItem("is_logged_in") || false,
  login_form: new LoginForm("", ""),
  login_errors: new LoginErrors(false, false),
  login_server_error: false,
  http_error: new HttpError(0, "", "")
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case LOGIN_USER:
      return {
        ...state,
        user: action.payload,
        is_logged_in: true,
        forgot_success_message: '',
        loading: false
      };

    case LOGOUT_USER:
      return {
        ...state,
        user: null,
        is_logged_in: false,
        loading: false
      }
    case FORGOT_PASSWORD:
      return {
        ...state,
        forgot_success: true,
        forgot_success_message: action.payload,
        loading: false
      }
    case ERROR:
      return {
        ...state,
        forgot_error: action.payload,
        forgot_success_message: '',
        loading: false
      }

    case SET_LOGIN_DATA:
      return {
        ...state,
        loading: false,
        login_errors: { ...state.login_errors, [action.payload.key]: action.payload.value === "" },
        login_form: { ...state.login_form, [action.payload.key]: action.payload.value.toString() }
      }

    case LOGIN_SERVER_ERROR:
      return {
        ...state,
        loading: false,
        login_server_error: action.payload.has_error,
        http_error: { status: action.payload.status, status_text: action.payload.status_text, message: action.payload.message }
      }

    case SET_LOGIN_ERRORS:
      return {
        ...state,
        loading: false,
        login_errors: { ...state.login_errors, [action.payload.key]: action.payload.value }
      }
    case START_LOADING:
      return {
        ...state,
        loading: true
      }

    default:
      return {
        ...state
      };
  };
};